"use strict";var Expander = require('makeup-expander');
var focusables = require('makeup-focusables');

module.exports = {
  handleExpand() {
    this.emit('base-expand');
  },

  handleCollapse() {
    this.emit('base-collapse');
  },

  onMount() {
    if (this.input.type !== 'dialog--mini') {
      this._setupMakeup();
    }
  },

  onUpdate() {
    if (this.input.type !== 'dialog--mini') {
      this._setupMakeup();
    }
  },

  onRender() {
    if (typeof window !== 'undefined') {
      this._cleanupMakeup();
    }
  },

  collapse() {
    this._expander.collapse();
  },

  expand() {
    this._expander.expand();
  },

  isExpanded() {
    return this._expander.isExpanded();
  },

  onDestroy() {
    this._cleanupMakeup();
  },

  _setupExpander(host, hostSelector) {
    var input = this.input;
    var type = input.type;
    var container = this.getEl('container');
    var isTooltip = type === 'tooltip';
    var isInfotip = type === 'infotip';
    var expanderEl = container.getElementsByClassName(type)[0];

    if (host) {
      this._expander = new Expander(expanderEl, {
        hostSelector: hostSelector,
        contentSelector: "." + type + "__overlay",
        expandedClass: type + "--expanded",
        focusManagement: null,
        expandOnFocus: isTooltip,
        expandOnHover: isTooltip && !input.noHover,
        expandOnClick: isInfotip,
        autoCollapse: isTooltip });


      if (isTooltip && !host.hasAttribute('aria-describedby')) {
        host.setAttribute('aria-describedby', input.overlayId);
      }
    }
  },

  _setupMakeup() {var _this = this;
    var input = this.input;
    var type = input.type;
    var container = this.getEl('container');
    var hostClass = type + "__host";
    var hostSelector = "." + hostClass;
    var host = container.querySelector(hostSelector);

    if (!host) {
      if (this.cancelFocus) {
        this.cancelFocus();
      }

      this.cancelFocus = focusables(container, false, function (curFocusables) {
        var curFocusable = curFocusables[0];
        if (curFocusable) {
          host = curFocusable;

          if (!curFocusable.classList.contains(hostClass)) {
            curFocusable.classList.add(hostClass);
          }
        }
        _this._setupExpander(host, hostSelector);
      });
    } else {
      this._setupExpander(host, hostSelector);
    }
  },

  _cleanupMakeup() {
    if (this.cancelFocus) {
      this.cancelFocus();
    }

    if (this._expander) {
      this._expander.cancelAsync();
      this._expander = undefined;
    }
  } };